﻿/// Author: Petronella van Tonder
/// Mar,  2020
/// Last modified: Mar 2, 2020
import { showMessage, reportError, wrapFetch, checkFetch } from './utils';
import InfiniteGrid, { GridLayout } from '@egjs/infinitegrid';
const productsGrid = document.getElementById('products-grid');
const form = document.getElementById('catalog-form');
let canAddProducts = true;
let nextProductId = 0;

/**
 * Creates html elements from a string.
 * @param {string} str
 */
function createElementsFromString(str) {
	let div = document.createElement('div');
	div.innerHTML = str;
	return div.childNodes;
}

function connectProduct(element) {
	const changeButton = element.querySelector('button.shopping-cart-change');
	if (changeButton != null) {
		const productId = element.getAttribute('data-product');
		const productName = element.getAttribute('data-product-name');
		//const removeButton = element.querySelector('input[type=button].shopping-cart-remove');
		const amountInput = element.querySelector('input.shopping-cart-amount');
		const previousAmount = element.getElementsByClassName("hidden-shopping-cart-amount")[0];
		changeButton.addEventListener('click', async () => {
			try {
				const res = await wrapFetch(fetch(`https://${window.location.host}/Catalog/ChangeProduct`, {
					method: 'post',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					body: `product=${productId}&amount=${amountInput.value}`,
					credentials: 'same-origin'
				}));
				await checkFetch(res);
				amountInput.value = parseInt(await res.text(), 10);
				RefreshClientShoppingCartTotal(amountInput, previousAmount.innerHTML);
				previousAmount.innerHTML = amountInput.value;
			} catch (err) {
				showMessage(`Failed to change the amount of ${productName} in your shopping cart! Error: ${err}`, 'danger');
				reportError(err);
			}
		});
		/*addButton.addEventListener('click', async () => {
			try {
				const res = await fetch(`https://${window.location.host}/Catalog/AddProduct`, {
					method: 'post',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					body: 'product=' + productId,
					credentials: 'same-origin'
				});
				await checkFetch(res);
				amountInput.value = parseInt(await res.text(), 10);
				RefreshClientShoppingCartTotal(amountInput, previousAmount.innerHTML);
				previousAmount.innerHTML = amountInput.value;
			} catch (err) {
				showMessage(`Failed to add ${productName} to your shopping cart! Error: ` + err, 'danger');
				reportError(err);
			}
		});
		removeButton.addEventListener('click', async () => {
			try {
				const res = await fetch(`https://${window.location.host}/Catalog/RemoveProduct`, {
					method: 'post',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					body: 'product=' + productId,
					credentials: 'same-origin'
				});
				amountInput.value = parseInt(await res.text(), 10);
			} catch (err) {
				showMessage(`Failed to remove ${productName} from your shopping cart!`);
				console.warn(err);
			}
		});
		*/
		amountInput.addEventListener('keydown', async (e) => {
			if (e.keyCode == 13) {
				e.preventDefault();
				try {
					const res = await wrapFetch(fetch(`https://${window.location.host}/Catalog/ChangeProduct`, {
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						},
						body: `product=${productId}&amount=${amountInput.value}`,
						credentials: 'same-origin'
					}));
					await checkFetch(res);
					amountInput.value = parseInt(await res.text(), 10);
					RefreshClientShoppingCartTotal(amountInput, previousAmount.innerHTML);
					previousAmount.innerHTML = amountInput.value;
				} catch (err) {
					showMessage(`Failed to change the amount of ${productName} in your shopping cart! Error: ` + err, 'danger');
					reportError(err);
				}
				return false;
			}
			return true
		});
	}
	element.getElementsByClassName("showDetails")[0]?.addEventListener("click", ToggleDetails);
	//element.getElementsByClassName("shopping-cart-amount")[0].addEventListener("change", submitForm);
	//element.getElementsByClassName("shopping-cart-add")[0].addEventListener("click", submitForm);
}

async function addProductEntry() {
	if (canAddProducts && !ig.isProcessing()) {
		canAddProducts = false;
		try {
			const url = `https://${window.location.host}/Catalog/_ProductTemplate`;
			const data = new FormData(form);
			data.append('index', nextProductId);
			nextProductId++;
			// Fetch the product view.
			let res = await wrapFetch(fetch(url, {
				method: 'post',
				body: data,
				credentials: 'same-origin'
			}));
			await checkFetch(res);
			res = await res.text();
			if (res !== '') {
				let elems = [];
				res = createElementsFromString(res);
				for (let elem of res)
					if (elem instanceof Element) {
						connectProduct(elem);
						elems.push(elem);
					}
				ig.append(elems);
			}
		} catch (err) {
			showMessage('Failed to load next product:' + err, 'danger');
			reportError(err);
		}
		canAddProducts = true;
	}
}

function submitForm(e) {
	// Deselect other categories if selecting All.
	if (e.target.name === 'Categories' && e.target.value === '-1')
		for (let input of form.elements)
			if (input.name === 'Categories' && input.value !== '-1')
				input.checked = false;
	// Submit the form.
	form.submit();
}

// Create the grid.
const ig = new InfiniteGrid(productsGrid, {
	horizontal: false,
});
ig.setLayout(new GridLayout({
	itemSize: 300,
	align: "start",
	margin: 50
}));
// Append products.
ig.on('append', addProductEntry);
addProductEntry();
// Submit the form wa category changes.
for (let input of form.elements)
	if (input.name === 'Categories')
		input.addEventListener('change', submitForm);

function ToggleDetails(_sender) {
	_sender.target.parentNode.parentNode.getElementsByClassName("product-details")[0].classList.toggle("hide");

}//end ToggleDetails

var shoppingCartTotal = document.getElementById("shopping-cart-link-amount");
function RefreshClientShoppingCartTotal(_sender, _previousTotal) {
	console.log("Equation: " + shoppingCartTotal.innerHTML + " - " + _previousTotal + " + " + _sender.value + " = " + ((Number(shoppingCartTotal.innerHTML) - Number(_previousTotal)) + Number(_sender.value)));
	shoppingCartTotal.innerHTML = (Number(shoppingCartTotal.innerHTML) - Number(_previousTotal)) + Number(_sender.value);

}//end RefreshClientShoppingCartTotal